import { get, forEach } from 'lodash';

import FeatureFlags from '../FeatureFlags';

const hasCapability = (user, capability) => get(user, 'capabilities', []).includes(capability);

const isInAgencies = (user, agencies) => {
  let ret = false;
  forEach(agencies, agency => {
    ret = ret || get(user, 'agency.agencyCode') === agency;
  });
  return ret;
};

export const isSuperAdmin = user => hasCapability(user, 'superadmin');
export const isContentManager = user =>
  isSuperAdmin(user) ||
  hasCapability(user, 'contentmanager') ||
  isInAgencies(user, get(FeatureFlags, 'allContentManagerAgencies.agencies'));
export const isRetail = user => isSuperAdmin(user) || hasCapability(user, 'retail');
export const isAdmin = user => isSuperAdmin(user) || get(user, 'agency.admins', []).includes(get(user, 'userId', ''));
export const isBasic = user => {
  // Show basic routes if:
  // 1. User is not retail, OR
  // 2. User is retail BUT also superadmin, lead agent, or content manager
  return !isRetail(user) || isSuperAdmin(user) || isAdmin(user) || isContentManager(user);
};

export const isAuthenticated = user => {
  return !!user;
};
